module.exports = __webpack_public_path__ + "img/logo_propesca.c97dd48e.svg";